import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { UpdateContactForm } from './UpdateContactForm';
import { trpc } from '@web/lib/trpc';
import { ContactWithDetails } from '@shared/types/ContactWithDetails';
import UpdateContactDialogFormSkeleton from './UpdateContactDialogFormSkeleton';
import UpdateContactDialogError from './UpdateContactDialogError';

const UpdateContactDialog = ({
  isOpen,
  setIsOpen,
  contactId,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contactId: string | null;
}) => {
  const {
    data: contactDetailsData,
    isFetching,
    isError,
    isSuccess,
  } = trpc.contact.getContact.useQuery(
    { contactId: contactId ?? '' },
    {
      enabled: isOpen && contactId != null,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  );

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-blackA6 data-[state=open]:animate-overlayShow fixed inset-0 z-40">
          <Dialog.Content className="data-[state=open]:animate-contentShow fixed left-1/2 top-1/2 z-50 h-[600px] w-[450px] -translate-x-1/2 -translate-y-1/2 overflow-y-scroll rounded-md bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
            <Dialog.Title className="mb-3 font-medium">
              Edit contact
            </Dialog.Title>

            {isFetching ? (
              <UpdateContactDialogFormSkeleton />
            ) : isError ? (
              <UpdateContactDialogError contactId={contactId} />
            ) : isSuccess ? (
              <UpdateContactForm
                contactDetails={contactDetailsData as ContactWithDetails}
                setIsDialogOpen={setIsOpen}
              />
            ) : null}
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default UpdateContactDialog;
